<template>
    <div id="content" class="microContent">
        <div class="microClassNum" v-show="isShowCount">共{{microList.length>0 ?6352:0}}份微课</div>
        <div class="microClassList">
            <div style="min-height:500px;"  v-if="pageTotal == 0">
              <Row type="flex" style="text-align: center;">
                <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt="" style="margin-top: 200px;"></Col>
                <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
              </Row>
            </div>
             <Row :gutter="27" v-else v-for="(item,index) in microList" :key="index" style="margin-bottom:15px;">
                <Col span="6" v-for="(n,m) in item" :key="m">
                    <div class="microBox" @click="videoPlayer(n.videoId,n.name,1,n.id)">
                        <div class="microImgBoxs">
                            <img class="microImgs" :src="imgurl+ n.imgurl" alt="">
                            <div class="mengBox">
                                <img src="/static/images/mengImg.png" alt="" class="meng">
                            </div>
                        </div>
                        <div class="microMsg">
                            <div class="microTitle" :title="n.name">{{n.name}}</div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="page" v-if="pageTotal > 20">
             <Page :total="pageTotal" :page-size="20" @on-change="changePage"/>
        </div>
        <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
    </div>
</template>
<script>
import api from '../../utils/api.js';
import bus from '../../assets/eventBus/enentBus.js';
import message from '../Message/Message'
import cookie from '../../assets/getCookie.js'
export default {
    name:'MicroClassList',
    components:{message},
    props:{
        seacheUrl:{
            type:String,
            default:'n'
        },
        subjectIdIndexLeft:{
          type:Number,
          default:null
        }

    },
    watch:{
        seacheUrl:function(newVal){
            this.url = newVal
        },
        subjectIdIndexLeft:function(newVal){
            this.subjectId = newVal
            this.getMicroData(1,this.gradeId,this.subjectId,this.versionId);
        }
    },
    data(){
        return{
            url:'/axt-future/knowledgeVideo/pageKnowledgeVideosByCondition',
            microList:null,                                         //微课列表  array
            imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
            microNum:null,                                          // 微课数量
            pageTotal:null,                                         //总页数
            gradeId:null,                                           //年级id  通过筛选按钮传过来
            versionId:null,                                         //版本id  通过筛选按钮传过来
            subjectId:null,                                         //学科id  通过筛选按钮传过来
            isShowMessage:false,
            msg:null,
            websiteId:null,
            shareSchoolId:null,
            handoutTeacherId:null,
            documentHeight:'',
            isShowCount:true
        }
    },
    created(){
        const that = this;

        if(that.gradeId == null && that.subjectId == null && that.versionId == null){
          this.isShowCount = true;
        }else {
          this.isShowCount = false;
        }
        bus.$off('MicroGradeId')
        bus.$on('MicroGradeId',function(msg){
            that.gradeId = msg;
            if(that.gradeId == null && that.subjectId == null && that.versionId == null){
              that.isShowCount = true;
            }else {
              that.isShowCount = false;
            }
            that.getMicroData(1,that.gradeId,that.subjectId,that.versionId);
        })
        bus.$off('subjectId')
        bus.$on('subjectId',function(msg){
            that.subjectId = msg;
            if(that.gradeId == null && that.subjectId == null && that.versionId == null){
              that.isShowCount = true;
            }else {
              that.isShowCount = false;
            }
             that.getMicroData(1,that.gradeId,msg,that.versionId);
        })
        bus.$off('versionId')
        bus.$on('versionId',function(msg){
            that.versionId = msg;
            if(that.gradeId == null && that.subjectId == null && that.versionId == null){
              that.isShowCount = true;
            }else {
              that.isShowCount = false;
            }
             that.getMicroData(1,that.gradeId,that.subjectId,that.versionId);
        })

    },
    mounted(){
        const that = this;
        this.websiteId = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+ this.websiteId +'_access_token')
        if(cookie_token){
            if(cookie_token != 'null'){
                this.isShowDownloadBtn = true;
                this.shareSchoolId = localStorage.getItem('schoolId');
                this.handoutTeacherId = localStorage.getItem('userId');
                this.userType = localStorage.getItem('userType');
            }
        }else{
            this.isShowDownloadBtn = false;
        }
        if(this.subjectIdIndexLeft != null){
          that.getMicroData(1,that.gradeId,that.subjectId,that.versionId);
        }

    },
    updated(){
        // this.documentHeight = this.$refs.ImgBoxWidth0[0].clientWidth*9/16+'px'
    },
    methods:{
        //获取微课列表
        getMicroData(pageNo,gradeIds,subjectId,versionId){
            const that = this;
            const result = [];
            that.microList = null;
            const params = {
                pageSize:20,
                pageNo:pageNo,
                gradeIds:gradeIds,
                subjectId:subjectId,
                versionId:versionId,
                distinct_videoId:1,
                websiteId:this.websiteId
            }
            api.getListAPI(this.url,params).then(res => {
                if (res.data.success) {
                  if(res.data.data == null && res.data.data.rows.length == 0){
                    that.pageTotal = 0;
                    that.microNum = 0;
                  }else {
                    that.microNum = res.data.data.total;                        //微课总数量
                    that.pageTotal = res.data.data.total;                   //分页总数
                    const microList = res.data.data.rows
                    for(let i=0;i < microList.length;i+=4){
                        result.push(microList.slice(i,i+4));
                    }
                    that.microList = result;
                  }
                   // console.log('microlist',that.microList)
                }else{
                    that.microList = []
                    // that.$Message.error(res.data.message);
                }
            })
        },
        //翻页
        changePage(page){
            const that = this;
            this.getMicroData(page,that.gradeId,that.subjectId,that.versionId);
        },
        //点击播放
        videoPlayer(videoId,name,sourse,id){
            if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                this.isShowMessage = true;
                this.msg = ('您尚未登录');
                this.tabType = number;
                return
            }
            this.$emit('showPlayer',true)
            const vidoeData = {
                videoId:videoId,
                name:name,
                sourse:sourse,
                id:id
            }
            this.$nextTick(() => {
                bus.$emit('videoId',vidoeData)
            })

        },
        isShowMsg(msg){
            this.isShowMessage = false;
        }
    }
}
</script>
<style lang="" scoped>
  .emptyImg {
    width: 320px;
  }
    .microContent{
        margin-top: 27px!important;
    }
    .microClassList {
      min-height: 500px;
    }
    .microClassNum{
        text-align: left;
        color: #9A9A9A;
        font-size: 14px;
        margin-bottom: 20px;
    }
    .microBox {
      border-radius: 4px;
      overflow: hidden;
    }
    .microBox:hover{
       /* margin-top: -10px; */
       animation: ImgHover .3s forwards;
        /* box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37); */
    }
    @keyframes ImgHover{
        form{margin-top: 0;box-shadow: 0px 0px 17px 0px rgba(255,255,255,0);}
        to{margin-top:-5px;box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37);}
    }
    .microBox:hover .microTitle{
        color:#3683FF;
    }
    .microImgs{
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);

    }
    .microImgsHover{
        display: inline-block;
        border-radius: 10px;
    }

    .microMsg{
        /* margin-bottom: 10px; */
    }
    .microTitle{
        padding: 0 5px 5px;
        font-size: 16px;
        color: #34495E;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /* 蒙版 */
    .microImgBoxs{
        position: relative;
        overflow: hidden;
        height: 157px;
    }
    .mengBox{
        width:100%;
        height: 100%;
        position: absolute;
        left: 0;
        top:0;
        z-index: 10;
        background:rgba(255, 255, 255, 0);
        border-radius: 4px;
    }
    .mengBox img{
        position: absolute;
        left: 50%;
        top: 50%;
        /* transform: translate(-50%,-50%); */
        margin-left: -33px;
        margin-top: -33px;
        opacity: 0;
    }
    .microBox:hover .mengBox{
        animation: mengHovar .3s forwards;
    }
    .microBox:hover .mengBox img{
        animation: mengImgHovar .3s forwards;
    }
    @keyframes mengHovar{
        from {background: rgba(255, 255, 255, 0);}
        to {background: rgba(0, 0, 0, 0.3);}
    }
    @keyframes mengImgHovar{
        from {opacity: 0;transform: scale(2);}
        to {opacity: 1;transform: scale(1);}
    }
</style>



// WEBPACK FOOTER //
// src/components/MicroClassList/MicroClassList.vue